/**
 * In-memory cache for presigned download URLs (per attachment id).
 */

export class AttachmentDownloadCache {
  constructor() {
    /** @type {Map<string, { url: string, fetchedAt: number }>} */
    this._entries = new Map();
  }

  /**
   * @param {string} attachmentId
   * @param {() => Promise<string>} fetcher
   */
  async getUrl(attachmentId, fetcher) {
    const id = String(attachmentId || "").trim();
    if (!id) throw new Error("attachment id required");
    const hit = this._entries.get(id);
    if (hit?.url) return hit.url;
    const url = await fetcher();
    if (!url) throw new Error("download unavailable");
    this._entries.set(id, { url, fetchedAt: Date.now() });
    return url;
  }

  clear() {
    this._entries.clear();
  }
}
